const isEmpty = (v) => {
  if (v == null || typeof v === "undefined") return true;                // null or undefined
  if (typeof v === 'string') return v.trim().length === 0;
  if (Array.isArray(v)) return v.length === 0;
  if (v instanceof Map || v instanceof Set) return v.size === 0;
  if (typeof v === 'object') return Object.keys(v).length === 0;
  return false;
}

export {isEmpty}